// extracted by mini-css-extract-plugin
export var arrows = "_7f-6";
export var decrementer = "_7f-a";
export var disabled = "_7f-4";
export var error = "_7f-1";
export var hiddenText = "_7f-b";
export var incrementer = "_7f-9";
export var input = "_7f-8";
export var inputWrapper = "_7f-0";
export var leadingIcon = "_7f-c";
export var readonly = "_7f-3";
export var regular = "_7f-7";
export var small = "_7f-5";
export var warning = "_7f-2";